module.exports = __webpack_public_path__ + "media/images/locations/circle/london-5bec5ac32e41cb5909e34fe46a972cb3.jpg";